module.exports = __webpack_public_path__ + "static/IMG-20200906-WA0027-34ad0d1dc16b992fa9d9364dd963e698.jpg";